(function() {
    BounceSettings.$inject = ['$scope', '__env', 'toastr', 'httpService', '$log'];

    angular
    	.module('app')
    	.component('bounceSettingsComponent', {
    		templateUrl: 'modules/emailSending/components/bounceSettings/bounceSettings.html',
    		controller: BounceSettings
    	});

    /**
     * Retrieves and updates Bounce settings.
     *
     * @class BounceSettings
     * @param { service } $scope - The scope of the component.
     * @param { service } __env - The environment configuration. 
     * @param { service } toastr - The third party toaster service.
     * @param { service } httpService - The http service used to make asynchronous rest calls
     * @param { service } $log - The service to log to console (or to file if needed)
     */
    function BounceSettings($scope, __env, toastr, httpService, $log) {
    	///////////////////////////////////////////////////////////////////////////
    	// Members
    	///////////////////////////////////////////////////////////////////////////	

    	$scope.$parent.pageTitle = 'Email Management Portal';
    	$scope.isLocked = true;
    	$scope.bounceSettings = {};
    	$scope.defaultBounceSettings = {};
    	
    	$scope.pageTitle = 'Bounce Settings';

    	

    	///////////////////////////////////////////////////////////////////////////
    	// Functions
    	///////////////////////////////////////////////////////////////////////////	

    	/**
         * Cancel button click handler that disables the fields and resets the values
         * to the default values
         *
         * @function cancelBounceEdit
         */
    	$scope.cancelBounceEdit = function() {			
    		$scope.bounceSettings = angular.copy($scope.defaultBounceSettings);	
    		$scope.isLocked = true;
    	};

    	/**
         * Edit button click handler that enables or disables editing
         *
         * @function editBounceSettings
         */
    	$scope.editBounceSettings = function() {
    		if($scope.isLocked) {
    			$scope.defaultBounceSettings = angular.copy($scope.bounceSettings);
    			$scope.isLocked = false;
    		} else {
    			$scope.cancelBounceEdit();
    		}
    	};

    	//this is the key I'm using: services/sendingservice/v1/emailstore

    	/**
         * Gets the bounce settings from the server to be displayed
         *
         * @function getBounceSettings
         */
    	$scope.getBounceSettings = function() {
    		var url = __env.consul;
    		var data = '';
    		var type = 'get';

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {

    				// set the variable that shows on the ui
    				$scope.bounceSettings = response.data;					

    			}).catch(function(e){

                    var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;
                                    
                    
                                 
                    $log.error(message);  
    				toastr.error('Your request for bounce settings bounced. Sorry!');				
    			});	
    	};

    	/**
         * Sends the new bounce settings to server to be updated
         *
         * @function updateBounceSettings
         */
    	$scope.updateBounceSettings = function() {
    		// send the new bounce settings
    		var url = __env.consul;
    		var data = this.bounceSettings;
    		var type = 'put';

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {				
    				$scope.isLocked = true;

    			}).catch(function(e){
    				toastr.error('Could not update the bounce settings.');		
                    var message = 'Status: ' + e.status + 
                                    '; Error:' + e.statusText;
                                    
                    $log.error(message);  
    				$scope.cancelBounceEdit();		
    			});	
    	};

    	$scope.init = function(){
    		$scope.getBounceSettings();
    	};

    	$scope.init();
    }
})();